import { useCallback } from 'react'

import { usePrivateIntegrationsSyncContext } from 'modules/integrations/hooks/SyncContext'

export function useApplyDataCollectionFilter() {
  const { dataCollectionSourceRef } = usePrivateIntegrationsSyncContext()

  return useCallback(
    (filters: Record<string, unknown>) => {
      const source = dataCollectionSourceRef.current
      if (source) {
        const setFilters = source.setCurrentFilters
        if (typeof setFilters === 'function') {
          setFilters(filters)
        }
      }
    },
    [dataCollectionSourceRef]
  )
}
